<template>
  <div>
    <basic-container>
      <el-form :model="info" :rules="rules" ref="infoForm" label-width="120px">
        <el-card shadow="hover" class="card">
          <div slot="header" class="clearfix">
            <span>商户报单信息:</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="销售部门" prop="region">
                <el-input v-model="info.region" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="施工地址(区/县)" prop="customAddress">
                <el-input v-model="info.customAddress" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="渠道" prop="appointmentType">
                <el-input v-model="info.appointmentType" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="户型" prop="houseType">
                <el-input v-model="info.houseType" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="安装形式" prop="installationForm">
                <el-input v-model="info.installationForm" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否拆原吊顶" prop="remove">
                <el-input v-model="info.remove" />
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="付款方式" prop="payType">
                <el-input v-model="info.payType" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="测量时间" prop="measureTime">
                <el-date-picker v-model="info.measureTime" type="datetime" placeholder="选择测量时间" />
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="20">
            <!-- <el-col :span="12">
              <el-form-item label="报单日期" prop="declarationDate">
                <el-date-picker v-model="info.declarationDate" type="date" placeholder="选择报单日期"
                  @change="handleDateChange" />
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="业务员" prop="salesperson">
                <el-input v-model="info.salesperson" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="进场时间" prop="entranceTime">
                <el-date-picker v-model="info.entranceTime" type="date" placeholder="选择预计进场时间"
                  @change="handleEntranceTimeChange" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="付款人手机号" prop="customMobile">
                <el-input v-model="info.customMobile" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="付款人姓名" prop="customName">
                <el-input v-model="info.customName" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- introducer装饰公司 -->
            <el-col :span="12">
              <el-form-item label="装饰公司" prop="introducer">
                <el-input v-model="info.introducer" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remarks">
                <el-input type="textarea" v-model="info.remarks" />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 商品选择表格保留 -->
          <el-form-item label="面积明细" prop="areaConfig">
            <el-table :data="info.areaConfig" style="width: 100%" border>
              <el-table-column prop="name" label="名称" width="180">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" />
                </template>
              </el-table-column>
              <el-table-column prop="length" label="长度(m)" width="220">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.length" :precision="2" :step="0.1" :min="0"
                    @change="calculateArea(scope.row)" />
                </template>
              </el-table-column>
              <el-table-column prop="width" label="宽度(m)" width="220">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.width" :precision="2" :step="0.1" :min="0"
                    @change="calculateArea(scope.row)" />
                </template>
              </el-table-column>
              <el-table-column prop="area" label="面积(㎡)" width="220">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.area" :precision="2" :step="0.1" disabled :min="0" />
                </template>
              </el-table-column>
              <!-- productName -->
              <el-table-column prop="productName" label="商品名称" width="220">
                <template slot-scope="scope">
                  <span v-if="scope.row.productName">{{ scope.row.productName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" @click="removeAreaItem(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" icon="el-icon-plus" @click="addAreaItem">添加</el-button>
          </el-form-item>
          <!-- 商品选择表格保留 -->
          <el-form-item label="商品列表" prop="selectedGoods">
            <el-table :data="selectedGoods" style="width: 100%" border>
              <el-table-column prop="goodsName" label="商品名称" />
              <el-table-column prop="num" label="数量" />
            </el-table>
            <!-- <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addGoods"
              v-if="selectedGoods.length === 0"
              >添加商品</el-button
            > -->
          </el-form-item>
        </el-card>
        <!-- 提交和返回按钮 -->
        <div class="btn-group">
          <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
          <el-button type="primary" size="small" @click="submit" icon="el-icon-circle-check-outline">确定修改</el-button>
        </div>
      </el-form>
    </basic-container>
  </div>
</template>
<script>
import {
  getMerchantOrder,
  editMerchantOrder,
  getAreaConfigById,
  getGoodList,
} from "@/api/work/ceiling/merchants";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
export default {
  data() {
    return {
      info: {
        region: "",
        customAddress: "",
        houseType: "",
        installationType: "",
        installationForm: "",
        remove: "",
        area: "",
        payType: "",
        measureTime: null,
        declarationDate: null,
        entranceTime: null,
        salesperson: "",
        customName: "",
        customMobile: "",
        remarks: "",
        introducer: "", // 装饰公司
      },
      selectedGoods: [],
      areaConfig: [], // 新增面积表格数据
      rules: {
        // region: [{ required: true, message: "请输入销售部门", trigger: "blur" }],
        appointmentType: [
          { required: true, message: "请输入渠道", trigger: "blur" },
        ],
        customAddress: [
          { required: true, message: "请输入施工地址(区/县)", trigger: "blur" },
        ],
        houseType: [{ required: true, message: "请输入户型", trigger: "blur" }],
        /* installationType: [
          { required: true, message: "请输入安装类型", trigger: "blur" },
        ],
        installationForm: [
          { required: true, message: "请输入安装形式", trigger: "blur" },
        ],
        remove: [
          { required: true, message: "请输入移除方式", trigger: "blur" },
        ],
        area: [{ required: true, message: "请输入面积", trigger: "blur" }],
        payType: [
          { required: true, message: "请输入付款方式", trigger: "blur" },
        ],
        measureTime: [
          { required: true, message: "请选择测量时间", trigger: "change" },
        ],
        declarationDate: [
          { required: true, message: "请选择报单日期", trigger: "change" },
        ], */
        entranceTime: [
          { required: true, message: "请选择进场时间", trigger: "change" },
        ],
        customName: [
          { required: true, message: "请输入付款人姓名", trigger: "blur" },
        ],
        customMobile: [
          { required: true, message: "请输入付款人手机号", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    const id = this.$route.query.id;
    if (id) {
      // 获取基本信息
      getMerchantOrder(id).then((res) => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          this.info = {
            ...this.info,
            ...data,
          };
          // 当data.list存在时使用，否则调用getGoodList接口获取数据
          if (data.list && data.list.length > 0) {
            this.processSelectedGoods(data.list);
          } else {
            // 调用getGoodList接口获取商品数据
            getGoodList(id).then(res => {
              if (res.code === '200') {
                let selectedGoods = JSON.parse(res.data);
               //  合并相同goodsId的商品数量
                selectedGoods.forEach(goods => {
                  if (goods.goodsId) {
                    let existingGoods = this.selectedGoods.find(g => g.goodsId === goods.goodsId);
                    if (existingGoods) {
                      existingGoods.num += goods.num;
                    } else {
                      this.selectedGoods.push(goods);
                    }
                  }
                })
              }

            })
          }
          // 单独获取面积配置
          this.getAreaConfig();
        }
      });
    }
  },
  methods: {
    // 单独获取面积配置数据
    getAreaConfig() {
      const id = this.$route.query.id;
      if (id) {
        getAreaConfigById(id).then((res) => {
          if (res.code == "200") {
            const areaData = JSON.parse(res.data);
            // 确保 info.areaConfig 存在
            if (!this.info.areaConfig) {
              this.info.areaConfig = [];
            }
            // 更新面积配置数据
            this.info.areaConfig = areaData || [];
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    handleDateChange(value) {
      this.info.declarationDate = value ? new Date(value).getTime() : null;
    },
    handleEntranceTimeChange(value) {
      this.info.entranceTime = value ? new Date(value).getTime() : null;
    },
    // 处理商品列表并回显
    processSelectedGoods(selectedGoods) {
      const type = "HANG_CEILING";
      // 使用导入的API函数，避免与方法名冲突
      findPureWaterGoodsByRootDepartId(type).then((res) => {
        if (res.code === "200") {
          let data = JSON.parse(res.data);
          if (data) {
            this.goodsList = this.transformToCascaderOptions(data);
            // 用于存储合并后的商品信息
            const mergedGoodsMap = new Map();
            // 确保selectedGoods是数组且不为空
            if (Array.isArray(selectedGoods) && selectedGoods.length > 0) {
              selectedGoods.forEach((g) => {
              // 先找到一级分类
              const parent = this.goodsList.find((item) =>
                item.children.some((child) => child.value == g.goodsId)
              );
              if (!parent) return;
              // 找到二级分类
              const child = parent.children.find(
                (child) => child.value == g.goodsId
              );
              const fullGoodsId = [parent.value, child.value];
              const fullName = parent.label + " / " + child.label;
              if (mergedGoodsMap.has(fullGoodsId.toString())) {
                // 如果商品已存在，合并数量
                const existingGoods = mergedGoodsMap.get(
                  fullGoodsId.toString()
                );
                existingGoods.num += g.num;
              } else {
                // 如果商品不存在，添加新商品
                mergedGoodsMap.set(fullGoodsId.toString(), {
                  goodsId: fullGoodsId,
                  num: g.num,
                  name: fullName,
                });
              }
            });
          }
          // 更新选中的商品列表
          this.selectedGoods = Array.isArray(selectedGoods) ? Array.from(mergedGoodsMap.values()) : [];
        }
      } else {
        this.$message({
          showClose: true,
          message: res.message,
          type: "error",
        });
      }
    });
  },
    transformToCascaderOptions(data) {
      return data.map((item) => ({
        value: item.id,
        label: item.name,
        children: item.filters.map((filter) => ({
          value: filter.id,
          label: filter.value,
        })),
      }));
    },
    goBack() {
      this.$router.go(-1);
    },
    // 添加面积项
    addAreaItem() {
      this.info.areaConfig.push({
        name: "",
        length: 0,
        width: 0,
        area: 0,
        declarationId: this.$route.query.id,
        sort: this.info.areaConfig.length + 1,
      });
    },
    // 删除面积项
    removeAreaItem(index) {
      this.info.areaConfig.splice(index, 1);
      // 重新排序
      this.info.areaConfig.forEach((item, i) => {
        item.sort = i + 1;
      });
    },
    // 计算面积
    calculateArea(row) {
      if (row.length && row.width) {
        row.area = Number((row.length * row.width).toFixed(2));
      } else {
        row.area = 0;
      }
    },
    // 在提交方法中处理面积数据
    submit() {
      const submitData = {
        ...this.info,
        areaConfig: this.info.areaConfig,
      };
      editMerchantOrder(submitData).then((res) => {
          console.log('edit.vue ~ line: 395 ~ res ->', res);
        if (res.code === "200") {
          this.$message.success("修改成功");
          this.goBack();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped>
.card {
  margin-bottom: 20px;
}
.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn-group {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
}
</style>
